import store from 'js/common/store';

export function persistCampaignInviteId(inviteId) {
    store.set('campaignInviteId', inviteId);
    return inviteId;
}

export function getCampaignInviteId() {
    return store.get('campaignInviteId');
}

export function removeCampaignInviteId() {
    store.remove('campaignInviteId');
}

export function persistReturnUrl(returnUrl) {
    store.set('returnUrl', returnUrl);
    return returnUrl;
}

export function getReturnUrl() {
    return store.get('returnUrl');
}

export function removeReturnUrl() {
    store.remove('returnUrl');
}

export function persistSocialConnectionState(value) {
    store.set('socialConnection', {value, expiresAt: null});
    return value;
}

export function getSocialConnectionState() {
    return store.get('socialConnection');
}

export function removeSocialConnectionState() {
    store.remove('socialConnection');
}


// WEBPACK FOOTER //
// ./creator/local_storage_client.js